<style scoped lang="scss">
.list-group {
  overflow: scroll;
}
</style>

<template>
  <section>
    <section class="d-none">
      <!-- Sites detail cards -->
      <b-card-group>
        <b-card
          border-variant="success"
          header-border-variant="success"
          header-text-variant="success"
          footer-border-variant="success"
          header-tag="header"
          footer-tag="footer"
          class="text-center"
        >
          <h5 slot="header" class="mb-0">SiteA</h5>
          <dl class="row mb-0">
            <dt class="col-sm-12 col-md-4 text-left text-md-right">Description</dt>
            <dd class="col-sm-12 col-md-8 text-left">Industrial 802.11 g/n/ac 2.4GHz and 5GHz Dual Radio Wireless Access Point</dd>
            <dt class="col-sm-12 col-md-4 text-left text-md-right">Device Type</dt>
            <dd class="col-sm-12 col-md-8 text-left">IWAP-3002-1AC</dd>
            <dt class="col-sm-12 col-md-4 text-left text-md-right">MAC</dt>
            <dd class="col-sm-12 col-md-8 text-left">28:60:46:A0:55:49</dd>
            <dt class="col-sm-12 col-md-4 text-left text-md-right">RSA Key Size</dt>
            <dd class="col-sm-12 col-md-8 text-left">2048 Bits</dd>
            <dt class="col-sm-12 col-md-4 text-left text-md-right">SHA 3.0</dt>
            <dd class="col-sm-12 col-md-8 text-left">AES 256 Bits</dd>
          </dl>
          <span slot="footer" class="small text-success">Offline For 25 Days</span>
        </b-card>
        <b-card
          border-variant="danger"
          header-border-variant="danger"
          header-text-variant="danger"
          footer-border-variant="danger"
          header-tag="header"
          footer-tag="footer"
          class="text-center"
        >
          <h5 slot="header" class="mb-0">SiteA</h5>
          <dl class="row mb-0">
            <dt class="col-sm-12 col-md-4 text-left text-md-right">Description</dt>
            <dd class="col-sm-12 col-md-8 text-left">Industrial 802.11 g/n/ac 2.4GHz and 5GHz Dual Radio Wireless Access Point</dd>
            <dt class="col-sm-12 col-md-4 text-left text-md-right">Device Type</dt>
            <dd class="col-sm-12 col-md-8 text-left">IWAP-3002-1AC</dd>
            <dt class="col-sm-12 col-md-4 text-left text-md-right">MAC</dt>
            <dd class="col-sm-12 col-md-8 text-left">28:60:46:A0:55:49</dd>
            <dt class="col-sm-12 col-md-4 text-left text-md-right">RSA Key Size</dt>
            <dd class="col-sm-12 col-md-8 text-left">2048 Bits</dd>
            <dt class="col-sm-12 col-md-4 text-left text-md-right">SHA 3.0</dt>
            <dd class="col-sm-12 col-md-8 text-left">AES 256 Bits</dd>
          </dl>
          <span slot="footer" class="small text-danger">Offline For 25 Days</span>
        </b-card>
      </b-card-group>
      <!-- Sites overview cards -->
      <b-card-group columns class="mb-6">
        <b-card
          bg-variant="success"
          text-variant="white"
          header="Success"
          class="text-center"
        >
          <p class="card-text">Lorem ipsum dolor sit amet.</p>
        </b-card>
        <b-card
          border-variant="success"
          header-border-variant="success"
          header-text-variant="success"
          footer-border-variant="success"
          header-tag="header"
          footer-tag="footer"
          class="text-center"
        >
          <div class="d-flex flex-column justify-content-lg-between align-items-center text-success">
            <h6 class="mb-0">SiteA</h6>
            <small>
              <font-awesome-icon :icon="faLink" class="mr-1"/>
              25 Days
            </small>
          </div>
          <h5 class="card-title">SiteA</h5>
          <p class="card-text">This card has supporting text below as a natural lead-in to additional content.</p>
          <p class="card-text">
            <small class="text-success">
              <font-awesome-icon :icon="faLink" class="mr-1"/>
              25 days
            </small>
          </p>
          <p class="card-text">Lorem ipsum dolor sit amet.</p>
        </b-card>
        <b-card bg-variant="success"
                text-variant="white"
                header="Success"
                class="text-center">
            <p class="card-text">Lorem ipsum dolor sit amet.</p>
        </b-card>
        <b-card bg-variant="danger"
                text-variant="white"
                header="Danger"
                class="text-center">
            <p class="card-text">Lorem ipsum dolor sit amet.</p>
        </b-card>
      </b-card-group>
    </section>
    <b-card-group class="d-none d-sm-flex">
      <b-card no-body class="col-sm-4 px-0" style="height: 200px;">
        <h6 class="text-center py-2 mb-0 border-bottom">
          <font-awesome-icon :icon="faSitemap" />
          Sites
        </h6>
        <b-list-group flush style="overflow: auto">
          <b-list-group-item href="#" class="d-flex flex-column flex-lg-row justify-content-between align-items-center">
            <span class="text-truncate">Cras justo odio</span>
            <small>
              <font-awesome-icon :icon="faLink" class="mr-1 mw-20"/>
              25 Days
            </small>
          </b-list-group-item>
          <b-list-group-item href="#" class="d-flex flex-column flex-lg-row justify-content-between align-items-center">
            <span class="text-truncate">Cras justo odio</span>
            <small>
              <font-awesome-icon :icon="faLink" class="mr-1 mw-20"/>
              25 Days
            </small>
          </b-list-group-item>
          <b-list-group-item href="#" class="d-flex flex-column flex-lg-row justify-content-between align-items-center">
            <span class="text-truncate">Cras justo odio</span>
            <small>
              <font-awesome-icon :icon="faLink" class="mr-1 mw-20"/>
              25 Days
            </small>
          </b-list-group-item>
          <b-list-group-item href="#" class="d-flex flex-column flex-lg-row justify-content-between align-items-center">
            <span class="text-truncate">Cras justo odio</span>
            <small>
              <font-awesome-icon :icon="faLink" class="mr-1 mw-20"/>
              25 Days
            </small>
          </b-list-group-item>
          <b-list-group-item href="#" class="d-flex flex-column flex-lg-row justify-content-between align-items-center">
            <span class="text-truncate">Cras justo odio</span>
            <small>
              <font-awesome-icon :icon="faLink" class="mr-1 mw-20"/>
              25 Days
            </small>
          </b-list-group-item>
          <b-list-group-item href="#" class="d-flex flex-column flex-lg-row justify-content-between align-items-center">
            Dapibus ac facilisis in
            <small>
              <font-awesome-icon :icon="faLink" class="mr-1"/>
              25 Days
            </small>
          </b-list-group-item>
          <b-list-group-item href="#" class="d-flex flex-column flex-lg-row justify-content-between align-items-center">
            Vestibulum at eros
            <small>
              <font-awesome-icon :icon="faLink" class="mr-1"/>
              25 Days
            </small>
          </b-list-group-item>
          <b-list-group-item href="#" class="d-flex flex-column flex-lg-row justify-content-between align-items-center">
            <span class="text-truncate">Cras justo odio</span>
            <small>
              <font-awesome-icon :icon="faLink" class="mr-1 mw-20"/>
              25 Days
            </small>
          </b-list-group-item>
          <b-list-group-item href="#" class="d-flex flex-column flex-lg-row justify-content-between align-items-center">
            <span class="text-truncate">Cras justo odio</span>
            <small>
              <font-awesome-icon :icon="faLink" class="mr-1 mw-20"/>
              25 Days
            </small>
          </b-list-group-item>
          <b-list-group-item href="#" class="d-flex flex-column flex-lg-row justify-content-between align-items-center">
            <span class="text-truncate">Cras justo odio</span>
            <small>
              <font-awesome-icon :icon="faLink" class="mr-1 mw-20"/>
              25 Days
            </small>
          </b-list-group-item>
          <b-list-group-item href="#" class="d-flex flex-column flex-lg-row justify-content-between align-items-center">
            <span class="text-truncate">Cras justo odio</span>
            <small>
              <font-awesome-icon :icon="faLink" class="mr-1 mw-20"/>
              25 Days
            </small>
          </b-list-group-item>
          <b-list-group-item href="#" class="d-flex flex-column flex-lg-row justify-content-between align-items-center">
            Dapibus ac facilisis in
            <small>
              <font-awesome-icon :icon="faLink" class="mr-1"/>
              25 Days
            </small>
          </b-list-group-item>
          <b-list-group-item href="#" class="d-flex flex-column flex-lg-row justify-content-between align-items-center">
            Vestibulum at eros
            <small>
              <font-awesome-icon :icon="faLink" class="mr-1"/>
              25 Days
            </small>
          </b-list-group-item>
        </b-list-group>
      </b-card>
      <b-card class="col-sm-8">
      </b-card>
    </b-card-group>
  </section>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import { faLink, faSitemap, faUnlink } from '@fortawesome/fontawesome-free-solid'

export default {
  props: {
    data: {
      type: [Array, Object],
      default: () => []
    }
  },
  components: {
    FontAwesomeIcon
  },
  data () {
    return {
      /* icons */
      faLink,
      faSitemap,
      faUnlink
    }
  },
  computed: {

  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/Card4Sites.vue